import type { Capability } from 'owa-capabilities';
import type { MailboxInfo } from 'owa-client-types';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isConsumer } from 'owa-session-store';
import { isBrowserSafari } from 'owa-user-agent';

/**
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 * This capability is being used to check in which platforms the header teams chat is enabled
 */
export const headerTeamsChatCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        return true; // This capability is enabled by default
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return (
            isFeatureEnabled('fwk-teamsSuite') &&
            !isFeatureEnabled('mon-hide-chat-integration') &&
            !isConsumer() &&
            !isBrowserSafari()
        );
    },
};
